module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/thurston_promo.8f9a162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/thurston_promo.jpg
// module id = rnLl
// module chunks = 1